import { MutableRefObject, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useClickOutside(ref: MutableRefObject<any>, cb: () => void) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target) && cb) {
        cb();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, cb]);
}
